module.exports = __webpack_public_path__ + "static/media/ostukorv.dcf79c94.png";